import React from 'react';
import SellerRatingBlock from '../seller-avatar-block/index';
import SellerContactBlock from '../seller-contact-block';
import SellerActionsBlock from '../seller-actions-block';
import { SellerInfoBlockContainer } from '../../app.style';

const SellerInfoBlock: React.FC<Props> = ({ isMobileCardsLayout }) => {
    return (
        <SellerInfoBlockContainer
            isMobileCardsLayout={isMobileCardsLayout}
            className="seller-info-block-container"
            data-q="reply-box-2"
        >
            <SellerRatingBlock />
            <div className="seller-contact">
                <SellerContactBlock />
                <SellerActionsBlock />
            </div>
        </SellerInfoBlockContainer>
    );
};

interface Props {
    isMobileCardsLayout: boolean;
}

export default SellerInfoBlock;
